import { css } from "styled-components";
export const MixinIcon = (props) => css `
  display: inline-block;
  mask-image: url("${props.icon}");
  mask-repeat: no-repeat;
  background-color: ${props.color};
  mask-size: cover;
`;
export const MixinSquareIcon = (props) => css `
  background-image: url("${props.icon}");
  background-size: contain;
  background-repeat: no-repeat;
`;
export const MixinIconReversable = css `
  transform: none /* rtl:scaleX(-1) */;
`;
//# sourceMappingURL=common.js.map